import API from '../../services/api';
import { getReportSolution } from '../../utils/solutions';
import calendarUtils from '../../utils/calendar';

const generateCommonFieldsReportObject = reportObject => {
  const { project, report, cmsId } = reportObject;

  if (!project || !report) return {};

  return {
    advertisers: report.advertisers,
    devices: [],
    email: report.email,
    endTime: '',
    filterByTime: report.filterByTime,
    filterByWeekday: report.filterByWeekday,
    format: report.format,
    medias: report.medias,
    speedUnit: project.preferences?.speedUnit || '',
    startTime: calendarUtils.replaceOffset(report.startDate, report.timezone),
    timezone: report.timezone,
    solution: report.solution,
    cmsId
  };
};

const generateSingleReportObject = reportObject => {
  const { project, report } = reportObject;
  if (!project || !report) return {};

  const baseReportObject = generateCommonFieldsReportObject(reportObject);

  const companyId = project.companyId;

  // Populate Devices list
  const devices = report?.devices?.map(deviceId => ({
    deviceId: deviceId,
    deviceName: `companies/${companyId}/devices/${deviceId}}`
  }));

  return {
    ...baseReportObject,
    devices,
    endTime: calendarUtils.replaceOffset(report.endDate, report.timezone),
    interval: String(report.interval.id).toUpperCase(),
    fields: report.fields // CSV columns to use on the Report
  };
};

const generateRecurringReportObject = reportObject => {
  const { report } = reportObject;

  if (!report) return {};

  const baseReportObject = generateCommonFieldsReportObject(reportObject);
  const devices = report?.devices?.map(deviceId => deviceId);
  const endDate = calendarUtils.addTime(99, 'years');
  delete baseReportObject.solution;

  return {
    ...baseReportObject,
    daysToSend: report.daysToSend,
    devices,
    endTime: calendarUtils.replaceOffset(endDate, report.timezone),
    frequency: report.frequency,
    interval: String(report.interval.id).toUpperCase()
  };
};

export const submit = async (report, project, selectedTemplate) => {
  if (report?.frequency === 'single') {
    const reportObject = {
      report,
      project,
      cmsId: selectedTemplate.cmsId || null
    };
    const data = generateSingleReportObject(reportObject);
    data.solutions = getReportSolution(selectedTemplate.compatibleDatasources);
    return API.createSingleReport(project.id, data);
  } else {
    const data = generateRecurringReportObject({
      report,
      project
    });
    data.solutions = getReportSolution(selectedTemplate.compatibleDatasources);
    return API.createRecurrentReport(project.id, selectedTemplate.table, data);
  }
};
